import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import IconButton from '../IconButton';
import { LinkIcon } from './CopyShareButton.styles';
import useCopyShare from '../../hooks/useCopyShare';
/**
 *
 * Themeable CopyShareButton component which provides link sharing functionality with the click of a button.
 *
 * By default, it logs 1 piwik event: `event(['share', 'copy', <link>]);`, but you can pass in a custom `piwikEvent` to log instead.
 *
 * This event is logged when the user copies a link. If choosing to continue with the default piwik events provided, a value must be provided for the `link` prop.
 *
 *
 * **Default Styles**
 *
 *To view the `CopyShareButton` styling directly, see [CopyShareButton.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/widgets/CopyShareButton/CopyShareButton.styles.js)
 *
 **/

export var CopyShareButtonComponent = function CopyShareButtonComponent(_ref) {
  var link = _ref.link,
      piwikEvent = _ref.piwikEvent,
      rest = _objectWithoutPropertiesLoose(_ref, ["link", "piwikEvent"]);

  var copyShare = useCopyShare(link, piwikEvent);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "copy",
    place: "top",
    effect: "solid",
    clickable: true,
    isCapture: true,
    globalEventOff: "click"
  }), /*#__PURE__*/React.createElement(IconButton, _extends({
    "data-tip": "Copied!",
    "data-for": "copy",
    "data-event": "click",
    onClick: function onClick() {
      return copyShare();
    }
  }, rest), /*#__PURE__*/React.createElement(LinkIcon, null)));
};
CopyShareButtonComponent.propTypes = {
  /** Link to be shared via clipboard */
  link: PropTypes.string,

  /** Optional custom event that is logged upon sharing with email. Must be an array in the form of `[category, action, name, value]`, though `name` and `value` are optional. */
  piwikEvent: PropTypes.array
};
var CopyShareButton = createThemedComponent('CopyShareButton', CopyShareButtonComponent);
export default CopyShareButton;